/**
 * @author Fernando Ruano
 * @file index.js
 * @description Labs Card Component
 */

// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

/**
 * Labs Card Component.
 * @return { Node } React Labs Card Component
 */
const LabsCard = ({
  title,
  subtitle,
  value,
  unities,
  footerIcon,
  footerText,
  type
}) => {
  const onGetCardBg = () => {
    switch (type) {
      case 'danger':
        return 'bg-stage-3b';
      case 'warning':
        return 'bg-stage-2';
      default:
        return 'bg-disabled';
    }
  };
  const textColor = type === 'normal' ? 'text-secondary' : 'text-white';
  return (
    <div
      className={`flex flex-col justify-between items-center bg-s p-1 w-36 h-36 ${onGetCardBg()} rounded-xl`}>
      <div className="flex flex-col justify-center items-center">
        <h3 className={`mb-0 text-base ${textColor}`}>{title}</h3>
        <h3 className={`mb-0 text-base ${textColor}`}>{subtitle}</h3>
      </div>
      <div
        className={`flex justify-center items-baseline ${
          footerText ? '' : 'mb-6'
        }`}>
        <h3 className={`mb-0 text-2xl font-bold ${textColor} mr-1`}>{value}</h3>
        <h3 className={`mb-0 text-base ${textColor} font-bold`}>{unities}</h3>
      </div>
      <div className="flex justify-center items-baseline">
        <h3 className={`mb-0 ${textColor} font-bold mr-2`}>{footerText}</h3>
        {footerIcon}
      </div>
    </div>
  );
};

/**
 * @name LabsCard.propTypes
 * @type { Object }
 */
LabsCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  value: PropTypes.number,
  unities: PropTypes.string,
  footerIcon: PropTypes.any,
  footerText: PropTypes.string,
  type: PropTypes.string
};

/**
 * Default props
 */
LabsCard.defaultProps = {
  footerIcon: null,
  type: 'normal'
};

export default LabsCard;
